import type { FilterableProperty } from '@talos/kyoko';
import { CustomerExecutionStrategyEnum, IconName } from '@talos/kyoko';
import { values } from 'lodash-es';
import { useMemo } from 'react';

/**
 * This hook creates the filter property definition for ExecutionStrategy properties.
 *
 * @param overrides Any overrides to make to the defaults here (e.g. `key`, etc.)
 * @returns Filter Property definition to use for ExecutionStrategy filters
 */
export function useExecutionStrategiesFilter<TKey extends string = 'ExecutionStrategies', P = FilterableProperty<TKey>>(
  overrides?: { [K in keyof P]: K extends keyof FilterableProperty<TKey> ? P[K] : never } & { key?: TKey }
) {
  return useMemo(
    () => ({
      ...({
        key: 'ExecutionStrategies' as TKey,
        field: 'ExecutionStrategy',
        label: 'Execution Strategy',
        icon: IconName.ArrowUpDown,
        options: values(CustomerExecutionStrategyEnum),
        getOptionLabel: (option: string) => option,
      } satisfies FilterableProperty<TKey>),
      ...overrides,
    }),
    [overrides]
  );
}
